var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.innaDescription = {
	init: function () {
		if(window.location.hash) {
			var datafilter = window.location.hash
			datafilter = (datafilter.length && datafilter[0] === '#') ? datafilter.slice(1) : datafilter;

			var description = document.getElementsByClassName('courseFilterDescription ' + datafilter);

			if(description.length) {
				description[0].classList.remove('hidden');
			}
		}

		$('.boxText .innaFilter .btn').click(function () {
			var datafilter = $(this).attr('data-filter-class');
			datafilter = (datafilter.length && datafilter[0] === '.') ? datafilter.slice(1) : datafilter;

			var description = document.getElementsByClassName('courseFilterDescription ' + datafilter);
			var descriptions = document.getElementsByClassName('courseFilterDescription');

			for (var i = 0; i < descriptions.length; i++ ) {
				descriptions[i].classList.add('hidden');
			}

			if(description.length) {
				description[0].classList.remove('hidden');
			}
		});
	}
};

site.courses = {
	init: function () {
		site.courses.bindDropdown();
	},

	bindDropdown: function () {
		$('.courses-dropdown-toggle').click(function () {
			$('body').removeClass('dropdown-open');
			$('.level1.open','#mainmenu').removeClass('open');
			var documentWidth = $(document).width() + 15;
			if (documentWidth < 1007) {
				return true;
			}

			var body = $('body');
			body.toggleClass('coursesDropdownOpen');
			if (!body.hasClass('coursesLoggedIn')) {
				$('#email').first().focus();
			}

			$('body.coursesDropdownOpen').on('click', function(e) {
				var $target = e.target;
				if (!$($target).closest('.courses-login-wrap').length) {
					$('body').removeClass('coursesDropdownOpen');
				}
			});

			return false;
		});
	}
};

site.coursesMixitup = {
	init: function () {
		var targetSelector = '.course';

		/**
		 * Reads a hash from the URL (if present), and converts it into a class
		 * selector string. E.g "#green" -> ".green". Otherwise, defaults
		 * to the targetSelector, equivalent to "all"
		 *
		 * @return {string}
		 */
		function getSelectorFromHash() {
			var hash = window.location.hash.replace(/^#/g, '');

			var selector = hash ? '.' + hash : targetSelector;
			return selector;
		}

		/**
		 * Updates the URL whenever the current filter changes.
		 *
		 * @param   {mixitup.State} state
		 * @return  {void}
		 */
		function setHash(state) {
			var selector = state.activeFilter.selector;
			var newHash = '#' + selector.replace(/^./g, '');

			if (selector === targetSelector && window.location.hash) {
				// Equivalent to filter "all", remove the hash

				history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
			} else if (newHash !== window.location.hash && selector !== targetSelector) {
				// Change the hash

				history.pushState(null, document.title, window.location.pathname + newHash); // or history.replaceState()
			}
		}

		// Instantiate and configure the mixer
		var mixer = mixitup('.coursesContainer', {
			selectors: {
				target: targetSelector
			},
			animation: {
				enable: true
			},
			load: {
				filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
			},
			callbacks: {
				onMixEnd: setHash // Call the setHash() method at the end of each operation
			}
		});

		window.onhashchange = function () {
			var selector = getSelectorFromHash();
			if (selector === mixer.getState().activeFilter.selector) return; // no change
			mixer.filter(selector);
		};
	}
};

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	if ($('.coursesContainer').length) {
		site.coursesMixitup.init();
	}

	// Touch login
	$('.login').dblclick(function (e) {
		e.preventDefault();
		window.location = '/moya';
	});

	site.courses.init();
	site.innaDescription.init();

	site.owl.init('#innaCourseView #reviews > div', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});

	site.owl.init('.box_inna_upcoming .innaCardList', {
		loop: true,
		dots: false,
		nav: true,
		margin: 30,
		navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
		responsive:{
			0: {
				items:1
			},
			768: {
				items:2
			},
			1000: {
				items:3
			},
			1500: {
				items:4
			}
		}
	});

	if ($('#inna .carousel .image').length > 0) {
		site.owl.init('#inna .carousel', {
			items: 1,
			nav: true,
			navText: ''
		});
	}

	site.owl.init('#innaCourseView .reviews', {
		items: 1,
		nav: true,
		navText: '',
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		smartSpeed: 900,
		loop: true
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
